import { useEffect, useState } from 'react';
import { differenceInSeconds } from 'date-fns';
import { parseISOorDate } from 'infrastructure/functions/parse-iso-or-date';
import { useInterval } from 'react-use';

const getSeconds = (date: Date | string) => {
  const assignedDate = parseISOorDate(date);
  const seconds = differenceInSeconds(new Date(), assignedDate);
  return seconds;
};

interface IProps {
  assignedAt?: string | Date | null;
}

export const useAssignedSecondsWatcher = ({ assignedAt }: IProps) => {
  const [assignedSeconds, setAssignedSeconds] = useState(0);

  const maxSeconds = 900; // 15 minute
  const intervalTime = 30_000;
  const isOverTime = assignedSeconds > maxSeconds;

  const updateTime = () => {
    if (!assignedAt) return;
    setAssignedSeconds(getSeconds(assignedAt));
  };

  useInterval(
    () => {
      updateTime();
    },
    isOverTime ? null : intervalTime,
  );

  useEffect(() => {
    updateTime();
  }, [assignedAt]);

  return { assignedSeconds, isOverTime };
};
